import { MAX_ALLOWED_HYBRIDS } from 'constants/values';
import { getCropIdByCrop } from 'crops/selectors';
import { getActiveCropId } from 'current/currentSelectors';
import { getSeedProductById } from 'products/planting-selectors';
import { getSeedProductSelectorValidationResult } from 'validations/selectors';
import { getProductValidationValues } from 'user/selectors';

import { compact, forEach, get, mapValues, range } from 'lodash';

export const getSearchParams = (state) => get(state, 'seedProductSelector.searchParams');
export const getSearchResults = (state) => get(state, 'seedProductSelector.searchResults');
export const getSearchStatus = (state) => get(state, 'seedProductSelector.searchStatus');
export const getSeedProductSelectorInputs = (state) => get(state, 'seedProductSelector.productInputs.seed');
export const getSeedSelectorProductInputs = (state) => {
  return forEach(getSeedProductSelectorInputs(state), (input) => { // forEach() returns a new object--not modifiying state.
    input.currentProduct = getSeedProductById(state, input.currentProductId);
  });
};
export const getActiveSeedProductIds = (state) =>
  compact(Object.values(getSeedSelectorProductInputs(state)).map((input) => input.currentProductId));
export const getActiveSeedProductsByInput = (state) => {
  return mapValues(getSeedSelectorProductInputs(state), (input) => {
    return getSeedProductById(state, input.currentProductId);
  });
};
export const getNumActiveSeedProducts = (state) => getActiveSeedProductIds(state).length;
export const canSelectMoreResults = (state) => getNumActiveSeedProducts(state) < MAX_ALLOWED_HYBRIDS;
export const hasDefinedRmRange = (state) => getActiveCropId(state) === getCropIdByCrop(state, 'soybeans');
export const getSeedProductRmValuesForCrop = (state, crop) => {
  const productValidationValues = getProductValidationValues(state);
  const { min, max, step } = productValidationValues.PLANTING[crop.toUpperCase()].RM;
  return hasDefinedRmRange(state)
    ? range(min, max + step, step).map((num) => num.toFixed(1))
    : [min, max];
};
export const searchFormIsValid = (state) => {
  return !getSeedProductSelectorValidationResult(state);
};
